import React, { Fragment, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import AddCountryForm from "./addCountryForm";

const AddCountry = () => {
  const initialObj = {
    country: null,
    state: [],
    isEnabled: false,
  };
  const [payload, setPayload] = useState(initialObj);
  return (
    <Fragment>
      <Breadcrumb title="Restricted Country" parent="add country" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Add Restricted Country</h5>
              </CardHeader>
              <CardBody>
                <AddCountryForm payload={payload} setPayload={setPayload} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddCountry;
